const ITEMS = [
  "Online Booking Now Open",
  "Handcrafted in Jaipur",
  "Solid Sheesham & Teak",
  "Made in Our Own Factory",
  "Pan-India Delivery",
  "Since 2013",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="bg-oxblood-ink border-y border-brass/20 py-5 overflow-hidden">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display italic text-ivory/80 text-xl md:text-2xl font-light px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-brass text-xs">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
